import type { User } from '../types'
import { canCreateOnBehalf } from './onBehalfAccess'

export type DovolenaUiRole = 'zadatel' | 'vedouci' | 'personalista' | 'spravce_rozvrhu' | 'nastaveni'

export function isDovolenaItAdmin(user: Pick<User, 'role' | 'admin_type'> | null | undefined): boolean {
  return user?.role === 'admin' && user.admin_type === 'spravce_it'
}

export function canActAsDovolenaZadatel(_user?: Pick<User, 'role' | 'admin_type'> | null): boolean {
  return true
}

/** Vedoucí: schvalování a/nebo podání jménem zaměstnance. */
export function canActAsDovolenaVedouci(user: Pick<User, 'role' | 'admin_type'> | null | undefined): boolean {
  if (!user?.role) return false
  if (isDovolenaItAdmin(user)) return true
  if (canCreateOnBehalf(user)) return true
  if (
    [
      'vedouci',
      'vedouci_executor',
      'zastupce_reditele',
      'director',
      'financist',
      'property_referent',
      'spravce_jidelny',
    ].includes(user.role)
  ) {
    return true
  }
  if (user.role === 'admin' && user.admin_type === 'spravce_budov') return true
  return false
}

export function canActAsDovolenaPersonalista(
  user: Pick<User, 'role' | 'admin_type'> | null | undefined,
): boolean {
  if (!user?.role) return false
  if (isDovolenaItAdmin(user)) return true
  return user.role === 'personalista' || user.role === 'director'
}

export function canActAsDovolenaSpravceRozvrhu(
  user: Pick<User, 'role' | 'admin_type'> | null | undefined,
): boolean {
  if (!user?.role) return false
  if (isDovolenaItAdmin(user)) return true
  return user.role === 'spravce_rozvrhu'
}

export function canActAsDovolenaNastaveni(
  user: Pick<User, 'role' | 'admin_type'> | null | undefined,
): boolean {
  return isDovolenaItAdmin(user)
}

export function labelDovolenaUiRole(role: DovolenaUiRole | null | undefined): string {
  switch (role) {
    case 'zadatel':
      return 'Žadatel'
    case 'vedouci':
      return 'Vedoucí'
    case 'personalista':
      return 'Personalista'
    case 'spravce_rozvrhu':
      return 'Správce rozvrhu'
    case 'nastaveni':
      return 'Nastavení'
    default:
      return ''
  }
}

export function userCanSelectDovolenaRole(
  user: Pick<User, 'role' | 'admin_type'> | null | undefined,
  role: DovolenaUiRole,
): boolean {
  switch (role) {
    case 'zadatel':
      return canActAsDovolenaZadatel(user)
    case 'vedouci':
      return canActAsDovolenaVedouci(user)
    case 'personalista':
      return canActAsDovolenaPersonalista(user)
    case 'spravce_rozvrhu':
      return canActAsDovolenaSpravceRozvrhu(user)
    case 'nastaveni':
      return canActAsDovolenaNastaveni(user)
    default:
      return false
  }
}
